export const SELECT_TEMPLATE = "SELECT_TEMPLATE";
export const LOAD_TEMPLATES = "LOAD_TEMPLATES";


export const selectTemplate = item  => {
  const result = {
    type: SELECT_TEMPLATE,
    payload: item
  }
  // sessionStorage.setItem('unitTemp', JSON.stringify(result.payload[0]));
  return result;
}

export const getTemplates = items  => {
  const result = {
    type: LOAD_TEMPLATES,
    payload: items
  }
  // sessionStorage.setItem('templates', JSON.stringify(result.payload));
  return result;
}